<template>
  <div class="w-[201px]" @click.stop>
    <!-- 筛选下拉框 -->
    <div class="w-full max-h-[550px] overflow-auto -mt-2">
      <a-collapse v-model:activeKey="activeKey" ghost>
        <a-collapse-panel
          v-for="(arr, key) in options"
          :key="key"
          :header="arr.title"
        >
          <div class="-mt-2">
            <div v-for="(item, key1) in arr.list" :key="key1">
              <div
                class="w-full h-9 flex justify-between items-center hover:bg-black-50 pl-7 pr-6"
                @click="getSelection(item.name, key)"
              >
                <span>{{ getProductNameIfNeed(item.name) }}</span>
                <span v-if="isSelected(item)">
                  <icon
                    icon="tick_mark.svg"
                    :width="14"
                    :height="14"
                    fill="none"
                /></span>
              </div>
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <!-- 分割线 -->
    <div v-if="selectionList.length" class="h-0.5 bg-black-50 mb-2"></div>
    <!-- 底部面包屑 -->
    <div class="max-h-28 w-full overflow-auto mb-1 px-[10px]">
      <div class="flex flex-wrap gap-[5px] gap-y-2">
        <div
          v-for="(item, key) in selectionList"
          :key="key"
          class="p-2 h-[26px] bg-black-50 rounded-[4px] flex items-center justify-center"
        >
          <span class="text-xs">{{ getProductNameIfNeed(item) }} </span>
          <span class="pl-[6px]" @click="handleClick(item)">
            <icon icon="delete2.svg" :width="12" :height="12" fill="none" />
          </span>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="flex justify-center gap-2 px-7 mt-7">
      <a-button
        class="w-[73px] h-[33px] text-[14px] border-none font-weight-bold bg-[#333] hover:bg-[#333]/[0.5] rounded-[8px]"
        @click="reset"
      >
        重置
      </a-button>
      <a-button
        type="primary"
        class="w-[73px] h-[33px] text-[14px] border-none font-weight-bold bg-[#0D84F2] rounded-[8px]"
        @click="submit"
      >
        完成
      </a-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useWatchfaceDevices } from '@/hooks';
import { computed, reactive, ref } from 'vue';
const { wholeDevices, getProductNameIfNeed } = useWatchfaceDevices();
const activeKey = ref([0]);
const options = computed(() => {
  return ['circle', 'square', 'run'].map((shape) => {
    return {
      title: shape == 'circle' ? '圆型' : shape == 'square' ? '方型' : '跑道型',
      list: wholeDevices.value
        .filter((item) => item.shape == shape)
        .map((item) => {
          return { name: item.deviceType, selected: false };
        })
    };
  });
});

const emits = defineEmits<{
  (event: 'finishSelect', selection: Array<string>): void;
}>();
const selectionList: Array<string> = reactive([]);

const getSelection = (name: string, key: number) => {
  let list = options.value[key].list;
  for (let i = 0; i < list.length; i++) {
    let item = list[i];
    if (item.name === name) {
      item.selected = item.selected ? false : true;
    }
  }
  if (selectionList.includes(name)) {
    selectionList.splice(selectionList.indexOf(name), 1);
  } else {
    selectionList.push(name);
  }
};
const isSelected = (item: { name: string }) => {
  return selectionList.some((name) => name === item.name);
};
const handleClick = (name: string) => {
  selectionList.splice(selectionList.indexOf(name), 1);
  options.value.forEach((option) => {
    for (let i = 0; i < option.list.length; i++) {
      let item = option.list[i];
      if (item.name === name) {
        item.selected = item.selected ? false : true;
      }
    }
  });
};
const reset = () => {
  for (let i = 0; i < 3; i++) {
    let list = options.value[i].list;
    for (let j = 0; j < list.length; j++) {
      list[j].selected = false;
    }
  }
  selectionList.splice(0, selectionList.length);
};
const submit = () => {
  emits('finishSelect', selectionList);
};

defineExpose({ reset });
</script>
<style scoped lang="less">
:deep(.ant-collapse-header) {
  opacity: 0.7;
  div {
    margin-top: -3px;
  }
}
:deep(.ant-collapse-content-box) {
  padding: 0px !important ;
}
</style>
